// update along with app/lib/enums/nutritional_panel_input_types.py
const NutritionalPanelInputTypes = {
  CSV: 'CSV',
  IMAGES: 'IMAGES',
};

const NutritionalPanelInputTypeLabels = {
  [NutritionalPanelInputTypes.CSV]: 'CSV',
  [NutritionalPanelInputTypes.IMAGES]: 'Images',
};

const NUTRITIONAL_PANEL_INPUT_TYPE_OPTIONS = [
  { value: NutritionalPanelInputTypes.CSV, label: 'CSV' },
  { value: NutritionalPanelInputTypes.IMAGES, label: 'Images' },
];

const NUTRITIONAL_PANEL_INPUT_TYPES = NutritionalPanelInputTypes;

export default NutritionalPanelInputTypes;
export {
  NUTRITIONAL_PANEL_INPUT_TYPES,
  NUTRITIONAL_PANEL_INPUT_TYPE_OPTIONS,
  NutritionalPanelInputTypeLabels,
};
